var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDomo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8364 9C19.3049 9 18.0276 10.0321 17.7356 11.4028V9L14.563 11.9999L11.3994 9V11.4028C11.1074 10.0321 9.83013 9 8.29857 9C6.76719 9 5.49 10.0319 5.19789 11.4024C5.0847 10.8717 4.82394 10.3918 4.45782 10.0029C3.87843 9.38753 3.03564 9 2.0973 9H0V15H2.0973C3.03561 15 3.8784 14.6125 4.45776 13.9971C4.82391 13.6083 5.08467 13.1283 5.19789 12.5976C5.49003 13.9681 6.76719 15 8.29857 15C9.83013 15 11.1074 13.9679 11.3994 12.5971V15H12.4478V11.4121L14.563 13.4178L16.669 11.4121V15H17.7356V12.5971C18.0276 13.9679 19.3049 15 20.8364 15C22.5836 15 24 13.6568 24 12C24 10.3431 22.5836 9 20.8364 9ZM2.2347 13.9971H1.04844V10.0029H2.23548C3.33684 10.0704 4.20828 10.9384 4.20828 12C4.20828 13.0617 3.33645 13.9299 2.2347 13.9971ZM8.29857 14.0018C7.13271 14.0018 6.18759 13.1055 6.18759 12C6.18759 10.8944 7.13271 9.99813 8.29857 9.99813C9.46443 9.99813 10.4095 10.8944 10.4095 12C10.4095 13.1055 9.46443 14.0018 8.29857 14.0018ZM20.8364 14.0018C19.6706 14.0018 18.7255 13.1055 18.7255 12C18.7255 10.8944 19.6706 9.99813 20.8364 9.99813C22.0023 9.99813 22.9474 10.8944 22.9474 12C22.9474 13.1055 22.0023 14.0018 20.8364 14.0018Z",
    fill: "#99CCEE"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDomo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/domo.07d22c1c6df3064931c966fa6fb39ba8.svg";